const GalleryCarousel = {
  parts: [
    'container',
    'containerInner',
    'headerSection',
    'mainHeading',
    'rightColumn',
    'subheading',
    'imageContainer',
    'imageGroup',
    'largeImageWrap',
    'smallImageWrap',
    'image',
    'imageOverlay',
    'ctaButton'
  ],
  baseStyle: {
    container: {
      overflow: 'hidden',
    },
    containerInner: {
      maxWidth: '1440px',
      mx: 'auto',
      display: 'flex',
      py: {base: 14, md: 30}, // 56px mobile, 120px desktop
      px: {base: 0, md: 0}, // 20px mobile, 0 desktop
      flexDirection: 'column',
      justifyContent: {base: 'flex-start', md: 'center'},
      alignItems: {base: 'flex-start', md: 'center'},
      gap: {base: 10, md: 20}, // 40px mobile, 80px desktop
      alignSelf: 'stretch',
    },
    headerSection: {
      display: 'flex',
      px: {base: 5, md: 20}, // 0 mobile (already padded by container), 80px desktop
      alignItems: {base: 'flex-start', md: 'center'},
      gap: {base: 4, md: 10}, // 16px mobile, 40px desktop
      alignSelf: 'stretch',
      flexDirection: {base: 'column', md: 'row'},
    },
    mainHeading: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90', // rgba(27, 26, 24, 0.90)
      fontFamily: 'heading',
      fontSize: {base: '28px', md: '40px'}, // 28px mobile, 40px desktop
      fontWeight: 'medium', // 500
      lineHeight: '120%',
      letterSpacing: {base: '-0.28px', md: '-0.4px'},
      flex: {base: 'none', md: '1 0 0'},
      mb: 0,
    },
    rightColumn: {
      display: 'flex',
      width: 'full',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 6, // 24px
      flex: {base: 'none', md: '1 0 0'},
    },
    subheading: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90',
      fontFamily: 'body',
      fontSize: {base: 'md', md: 'lg'}, // 16px mobile, 18px desktop
      fontWeight: 'normal',
      lineHeight: '160%',
    },
    imageContainer: {
      display: 'flex',
      pl: {base: 5, md: 20}, // 0 mobile (already padded by container), 80px desktop
      alignItems: 'center',
      gap: 1, // 4px
      alignSelf: 'stretch',
      overflow: 'hidden',
      sx: {
        '.swiper': {
          overflow: 'visible',
          width: 'full',
        },
        ' .swiper-slide': {
          width: 'auto',
        },
      },
    },
    imageGroup: {
      display: 'flex',
      gap: 1, // 4px
      alignItems: 'flex-start',
    },
    largeImageWrap: {
      position: 'relative',
      width: {base: '215px', md: '727px'}, // 215px mobile to match Figma
      height: {base: '266px', md: '495px'}, // 266px mobile to match Figma
      flexShrink: 0,
      overflow: 'hidden',
    },
    smallImageWrap: {
      position: 'relative',
      width: {base: '215px', md: '400px'}, // Match large image on mobile
      height: {base: '266px', md: '495px'}, // Match large image on mobile
      flexShrink: 0,
      overflow: 'hidden',
    },
    image: {
      width: 'full',
      height: 'full',
      objectFit: 'cover',
      position: 'absolute',
      top: 0,
      left: 0,
    },
    imageOverlay: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: {base: '68px', md: '84px'}, // 68px mobile to match Figma
      bg: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.40) 100%)',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      p: {base: 3, md: 5}, // 12px mobile, 20px desktop
      gap: 1, // 4px
    },
    ctaButton: {
      display: 'flex',
      width: {base: '216px', md: 'auto'}, // 216px mobile, auto desktop
      height: {base: '44px', md: '54px'}, // 44px mobile, 54px desktop
      minW: {base: '160px', md: '216px'}, // Minimum width constraints
      py: {base: '14px', md: 4}, // 14px mobile, 16px desktop
      px: {base: 12, md: 12}, // 48px both
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: {base: 'flex-start', md: 'center'}, // Left-aligned on mobile, centered on desktop
      gap: {base: 1.5, md: 2}, // 6px mobile, 8px desktop
      borderRadius: 'base', // 4px
      border: '1px solid',
      borderColor: 'brandColors.greyscale',
      bg: 'brandColors.greyscale',
      color: 'white',
      fontFamily: 'body',
      fontSize: 'sm', // 14px
      fontWeight: 'semibold', // 600
      lineHeight: '120%',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      flex: 'none',
      margin: '0 auto',
      whiteSpace: 'nowrap',
      _hover: {
        bg: 'transparent',
        color: 'brandColors.greyscale',
      },
    },
  },
};

export default GalleryCarousel;
